import { render, staticRenderFns } from "./CreditDebitTab.vue?vue&type=template&id=06b7c682&scoped=true"
import script from "./CreditDebitTab.vue?vue&type=script&lang=js"
export * from "./CreditDebitTab.vue?vue&type=script&lang=js"
import style0 from "./CreditDebitTab.vue?vue&type=style&index=0&id=06b7c682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b7c682",
  null
  
)

export default component.exports